module.exports = __webpack_public_path__ + "static/media/aq.d3e6fdf6.svg";